import { inject, Injectable, signal } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ENVIRONMENT_SERVICE_TOKEN } from '@mwe/constants';
import { Aktionscode, GueltigkeitsDetails } from '@mwe/models';

import { AccountLogic, EnvironmentService } from '@mwe/services';

@Injectable({
  providedIn: 'root',
})
export class NewVoucherService {
  private readonly http = inject(HttpClient);
  private readonly accountLogic = inject(AccountLogic);
  private readonly environmentService = inject<EnvironmentService>(ENVIRONMENT_SERVICE_TOKEN);

  private readonly voucherResourceUrl = signal<string>('');

  constructor() {
    this.voucherResourceUrl.set(this.environmentService.getApiUrl() + 'api/voucher/');
  }

  getVoucherDetail(voucherCode: string): Observable<Aktionscode> {
    const httpParams = this.getHttpParams();
    return this.http.get<Aktionscode>(`${this.getVoucherResourceUrl('details/')}${voucherCode}`, { params: httpParams });
  }

  getVoucherValidity(voucherCode: string, body: string): Observable<GueltigkeitsDetails> {
    const httpParams = this.getHttpParams();
    return this.http.post<GueltigkeitsDetails>(`${this.getVoucherResourceUrl('validity/')}${voucherCode}`, body, { params: httpParams });
  }

  private getVoucherResourceUrl(path?: string): string {
    const url = `${this.voucherResourceUrl()}${path ? path : ''}`;
    return this.accountLogic.isLoggedOut() ? url.replace('api', 'api/public') : url;
  }

  private getHttpParams(): HttpParams {
    const httpParams = new HttpParams();
    return this.accountLogic.isLoggedOut() ? httpParams.set('loggedIn', 'false') : httpParams;
  }
}
